import { render, staticRenderFns } from "./WxGoodsItem.vue?vue&type=template&id=166cef4a&scoped=true&"
import script from "./WxGoodsItem.vue?vue&type=script&lang=js&"
export * from "./WxGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./WxGoodsItem.vue?vue&type=style&index=0&id=166cef4a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166cef4a",
  null
  
)

export default component.exports